import FileTypeIcon from 'pages/MyFiles/FileTypeIcon';
import { getMyFileIconName } from 'pages/MyFiles/helper';

import { ReactComponent as DeleteIcon } from 'assets/icons/trash2.svg';
import Button from 'components/common/Button/Button';

export default ({ file, removeFile }) => {
  return (
    <div
      style={{
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.1)',
        borderRadius: '6px',
        transition: 'all 0.15s ease-out',
        cursor: 'pointer',
        height: '52px',
        background: 'var(--neutrals-slate-2, #f3f6fa)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 1rem',
        marginBottom: '0.5rem',
      }}
    >
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <FileTypeIcon type={file.type.split('/').at(-1)} />
        {file.name}
      </span>

      <Button variant="decline" startIcon={<DeleteIcon />} onClick={() => removeFile()} />
    </div>
  );
};
